/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browse_ShopInputs */

const en_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Shop`)
};

const es_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar tienda`)
};

const fr_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir la boutique`)
};

const de_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop durchsuchen`)
};

const ja_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショップを見る`)
};

const zh_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览店铺`)
};

const ar_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح المتجر`)
};

const id_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi Toko`)
};

const it_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora Negozio`)
};

const ru_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в магазин`)
};

const pt_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar Loja`)
};

const ko_browse_shop = /** @type {(inputs: Browse_ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어 둘러보기`)
};

/**
* | output |
* | --- |
* | "Browse Shop" |
*
* @param {Browse_ShopInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const browse_shop = /** @type {((inputs?: Browse_ShopInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browse_ShopInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_browse_shop(inputs)
	if (locale === "es") return es_browse_shop(inputs)
	if (locale === "fr") return fr_browse_shop(inputs)
	if (locale === "de") return de_browse_shop(inputs)
	if (locale === "ja") return ja_browse_shop(inputs)
	if (locale === "zh") return zh_browse_shop(inputs)
	if (locale === "ar") return ar_browse_shop(inputs)
	if (locale === "id") return id_browse_shop(inputs)
	if (locale === "it") return it_browse_shop(inputs)
	if (locale === "ru") return ru_browse_shop(inputs)
	if (locale === "pt") return pt_browse_shop(inputs)
	return ko_browse_shop(inputs)
});